import PropTypes from 'prop-types';
import { FaMoneyBillWave } from 'react-icons/fa';

import FORMATTERS from 'helpers/formatters';
import { Skeleton } from '_components/_core';
import {
  CustomCard,
  CustomCardBody,
  Label,
  Value,
} from '_components/Settings/components/SettingsV2/styles';

function ChargesTotalCard({ data, isLoading }) {
  const getTotalAmount = () => {
    if (!data || data.total_amount === undefined) {
      return 0;
    }

    return data.total_amount;
  };

  return (
    <CustomCard>
      <CustomCardBody>
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex flex-column align-items-start">
            <Label>Total</Label>
            {!isLoading && (
              <Value variant="large">{FORMATTERS.NUMBER(getTotalAmount())}</Value>
            )}
            {isLoading && <Skeleton />}
          </div>
          <FaMoneyBillWave size={24} className="text-muted" />
        </div>
      </CustomCardBody>
    </CustomCard>
  );
}

ChargesTotalCard.defaultProps = {
  data: null,
  isLoading: false,
  icon: null,
};

ChargesTotalCard.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
  icon: PropTypes.node,
};

export default ChargesTotalCard;
